import { useEffect } from "react";
import { API_URL } from "../api/api";

const TikTokCallbackPage = () => {
  useEffect(() => {
    const params = window.location.search;
    window.location.href = `${API_URL}/tiktok/callback${params}`;
  }, []);

  return null;
};

export default TikTokCallbackPage;
